import { IFieldInfo } from '../Queries/EkonomiskAnalysQuery/EkonomiskAnalysQuery';
import { MixedValueType } from '../../../../../../Types/GraphQLTypes';
import { getMixedValue } from '../../../../../../Components/QueryComponents/tedMixedUtils';
import { ekanalys_ekanalys_columns } from '../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';

export const getFieldInfoValue = (
  key: string,
  fieldInfos: IFieldInfo[]
): MixedValueType | null => {
  const fieldInfo = fieldInfos.find(x => x.name === key);
  if (fieldInfo && fieldInfo.value != null) {
    return getMixedValue(fieldInfo.value);
  } else {
    return null;
  }
};

export const getTypedFieldInfoValue = <T extends MixedValueType>(
  key: string,
  fieldInfos: IFieldInfo[]
): T => {
  return getFieldInfoValue(key, fieldInfos) as T;
};

export const fieldInfoToColumnData = (
  fieldInfos: IFieldInfo[]
): ekanalys_ekanalys_columns => {
  const columnData: Record<string, unknown> = {};
  fieldInfos.forEach(fieldInfo => {
    if (fieldInfo) {
      const value =
        fieldInfo.value != null ? getMixedValue(fieldInfo.value) : null;
      columnData[fieldInfo.name] = value;
    }
  });
  return columnData as unknown as ekanalys_ekanalys_columns;
};
